if (!customElements.get("purchase-guarantee-drawer")) {
  class PurchaseGuaranteeDrawer extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector(".m-drawer__wrapper");
      this.content = this.querySelector(".m-drawer__content");
      this.closeButton = this.querySelector(".m-drawer__close");
      this.bodyTarget = this.querySelector("[data-guarantee-drawer-content]");

      this.closeDrawer = this.closeDrawer.bind(this);
      this.onDrawerTriggerClick = this.onDrawerTriggerClick.bind(this);

      if (this.closeButton) {
        this.closeButton.addEventListener("click", (event) => {
          event.preventDefault();
          this.closeDrawer();
        });
      }

      if (this.wrapper) {
        this.wrapper.addEventListener("click", (event) => {
          if (event.target === this.wrapper) {
            this.closeDrawer();
          }
        });
      }

      if (this.bodyTarget) {
        this.bodyTarget.addEventListener("click", this.onDrawerTriggerClick);
      }
    }

    onDrawerTriggerClick(event) {
      const trigger = event.target.closest("[data-guarantee-drawer-trigger]");
      if (!trigger) return;

      this.toggleItem(trigger.dataset.guaranteeDrawerTrigger);
    }

    buildMarkup(items, activeIndex) {
      return items
        .map((item) => {
          const isActive = String(item.index) === String(activeIndex);

          return `
            <div class="sl-product-guarantee-drawer__item${isActive ? " is-active" : ""}">
              <button
                type="button"
                class="sl-product-guarantee-drawer__trigger"
                data-guarantee-drawer-trigger="${item.index}"
                aria-expanded="${isActive ? "true" : "false"}"
              >
                <span class="sl-product-guarantee-drawer__summary-main">
                  <span class="sl-product-guarantee-drawer__icon" aria-hidden="true">${item.icon}</span>
                  <span class="sl-product-guarantee-drawer__item-title">${item.title}</span>
                </span>
                <span class="sl-product-guarantee-drawer__chevron" aria-hidden="true"></span>
              </button>
              <div class="sl-product-guarantee-drawer__item-body rte"${isActive ? "" : " hidden"}>
                ${item.content}
              </div>
            </div>
          `;
        })
        .join("");
    }

    toggleItem(targetIndex) {
      if (!this.bodyTarget) return;

      const trigger = this.bodyTarget.querySelector(
        `[data-guarantee-drawer-trigger="${targetIndex}"]`
      );
      const item = trigger && trigger.closest(".sl-product-guarantee-drawer__item");
      const body = item && item.querySelector(".sl-product-guarantee-drawer__item-body");

      if (!trigger || !item || !body) return;

      const nextExpanded = trigger.getAttribute("aria-expanded") !== "true";
      item.classList.toggle("is-active", nextExpanded);
      trigger.setAttribute("aria-expanded", nextExpanded ? "true" : "false");
      body.hidden = !nextExpanded;
    }

    openDrawer(items, activeIndex) {
      if (!this.wrapper || !this.content || !this.bodyTarget) return;

      this.bodyTarget.innerHTML = this.buildMarkup(items, activeIndex);

      if (window.innerWidth < 770) {
        this.wrapper.classList.add("mobile");
      }

      this.wrapper.classList.remove("m:hidden");
      requestAnimationFrame(() => {
        this.wrapper.style.setProperty("--m-bg-opacity", "0.5");
        this.content.style.setProperty("--m-translate-x", "0");
      });
    }

    closeDrawer() {
      if (!this.wrapper || !this.content) return;

      this.wrapper.style.setProperty("--m-bg-opacity", "0");
      this.content.style.setProperty("--m-translate-x", "100%");

      setTimeout(() => {
        this.wrapper.classList.add("m:hidden");
        this.wrapper.classList.remove("mobile");
      }, 300);
    }
  }

  customElements.define("purchase-guarantee-drawer", PurchaseGuaranteeDrawer);
}

if (!customElements.get("sl-purchase-guarantee")) {
  class SLPurchaseGuarantee extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector("purchase-guarantee-drawer");
      this.triggers = this.querySelectorAll("[data-guarantee-content-id]");
    }

    getItems() {
      return Array.from(this.triggers).map((trigger) => {
        const templateId = trigger.dataset.guaranteeContentId;
        const template = templateId && this.querySelector(`#${templateId}`);
        const icon = trigger.querySelector(".sl-product-guarantee__icon");

        return {
          index: trigger.dataset.guaranteeIndex || "",
          title: trigger.dataset.guaranteeTitle || "",
          icon: icon ? icon.innerHTML : "",
          content: template ? template.innerHTML : "",
        };
      });
    }

    connectedCallback() {
      if (!this.drawer || !this.triggers.length) return;

      if (!this.drawer.dataset.movedToBody) {
        document.body.appendChild(this.drawer);
        this.drawer.dataset.movedToBody = "true";
      }

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.drawer.openDrawer(
            this.getItems(),
            trigger.dataset.guaranteeIndex || ""
          );
        });
      });
    }
  }

  customElements.define("sl-purchase-guarantee", SLPurchaseGuarantee);
}
